import {
  UilSignin,
  UilUser,
  UilInfoCircle,
  UilSignout,
  UilCommentInfo,
} from '@iconscout/react-unicons';
import {
  LoadingButton,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Notification,
  Waiting,
  ConfirmDialog,
  DialogContentText,
} from '@xbotvn/mui';
import React, {
  useState, useMemo, useEffect,
} from 'react';
import {
  useDispatch, useSelector,
} from 'react-redux';
import { useHistory } from 'react-router-dom';

import { DEFAULT_ROUTE } from '../../Routes';
import {
  app,
} from '../../libs/firebase';
import {
  getOr,
  filter,
} from '../../libs/lodash';
import {
  SIGN_OUT,
} from '../../redux/actions/constants';

import UserInfo from './UserInfo';
import UserLogin from './UserLogin';

export default function UserAccountButton() {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    user,
    handling,
    members,
  } = useSelector((state) => ({
    user: state.user,
    handling: getOr(false, 'handling', state.user),
    members: state.member.data,
  }));

  const [userLogin, setUserLogin] = useState();
  const [userInfo, setUserInfo] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [expire, setExpire] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const checkExpire = (new Date() > new Date(filter(({ email }) => email === user?.email, members)[0]?.endDate));
    setExpire(checkExpire);
  }, [members], [user]);

  const renderDialogExpire = useMemo(() => (
    <ConfirmDialog
      title="Tài khoản đã hết hạn"
      color="warning"
      Icon={UilCommentInfo}
      open={expire}
      onClose={() => setExpire(false)}
      cancelLabel="Đồng ý"
    >
      <DialogContentText>
        Tài khoản đã hết hạn vui lòng liên hệ quản lý thư viện để gia hạn.
      </DialogContentText>
    </ConfirmDialog>
  ));

  return (
    <>
      {renderDialogExpire}
      {handling && <Waiting fullscreen />}
      {userLogin && (
        <UserLogin
          user={user}
          onClose={() => setUserLogin(false)}
        />
      )}
      {userInfo && <UserInfo user={user} onClose={() => setUserInfo(undefined)} />}
      {user._id ? (
        <>
          <Button
            size="medium"
            variant="text"
            onClick={handleClick}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}
            >
              {user?.photo ? <img loading="eager" src={user.photo} alt="ava" height="20" /> : <UilUser />}
              <span style={{
                marginLeft: 10,
              }}
              >
                {getOr('Tài khoản', 'name', user)}
              </span>
            </div>
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem
              onClick={() => {
                setUserInfo(true);
                handleClose();
              }}
            >
              <ListItemIcon>
                <UilInfoCircle />
              </ListItemIcon>
              <ListItemText>Thông tin tài khoản</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                localStorage.removeItem('token');
                dispatch({
                  type: SIGN_OUT,
                });
                app.auth().signOut().catch((error) => {
                  Notification.error(error.message);
                });
                history.push(DEFAULT_ROUTE);
              }}
            >
              <ListItemIcon>
                <UilSignout />
              </ListItemIcon>
              <ListItemText>Đăng xuất</ListItemText>
            </MenuItem>
          </Menu>
        </>
      )
        : (
          <LoadingButton
            variant="text"
            size="medium"
            loading={user.handling}
            disabled={user.handling}
            onClick={() => setUserLogin(true)}
            startIcon={<UilSignin />}
          >
            Đăng nhập
          </LoadingButton>
        )}
    </>
  );
}
